import SearchPanel from './search-panel';

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/components/search-panel/index.js